// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__25FKq","footer":"styles_footer__2nUZw","passCodeTooltip":"styles_passCodeTooltip__1-8Nj"};